"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
require("mapbox-gl/dist/mapbox-gl.css");
var mapbox_gl_1 = __importDefault(require("mapbox-gl"));
var react_1 = require("react");
function useMapbox(ref, accessToken, options) {
    var _a = react_1.useState(), mapInstance = _a[0], setMapInstance = _a[1];
    react_1.useEffect(function initializeMap() {
        var container = ref.current;
        if (mapInstance || !container) {
            return;
        }
        mapbox_gl_1["default"].accessToken = accessToken;
        var mergedOptions = __assign(__assign({ container: container }, defaultOptions), options);
        var map = new mapbox_gl_1["default"].Map(mergedOptions);
        setMapInstance(map);
    }, [ref, accessToken, options]);
    return mapInstance;
}
exports.useMapbox = useMapbox;
var defaultOptions = {
    center: [-77.0305, 38.8868],
    style: 'mapbox://styles/mapbox/streets-v11',
    zoom: 9
};
//# sourceMappingURL=index.js.map